    <main>
      <section class="itinerary">
        <div class="container">
          <div class="itinerary_wrapper">
            <div class="itinerary_step">
              <a href="#">
            <!--    <img src="assets/img/step1-01.png" alt="step" /> -->
                <ul>
                  <li class="steps_active">
                    <iconify-icon icon="clarity:date-solid-badged"></iconify-icon>
                    <span>出發日期</span>
                  </li>
                  <li >
                    <iconify-icon
                      icon="streamline:information-circle-solid"
                    ></iconify-icon>
                    <span>輸入顧客資料 </span>
                  </li>
                  <li>
                    <iconify-icon
                      icon="fluent-mdl2:waitlist-confirm"
                    ></iconify-icon>
                    <span>確認資料</span>
                  </li>
                  <li>
                    <iconify-icon icon="streamline:payment-10-solid"></iconify-icon>
                    <span>網上付款</span>
                  </li>
                  <li>
                    <iconify-icon icon="grommet-icons:validate"></iconify-icon>
                    <span>完成</span>
                  </li>
                </ul>
    
              </a>
            </div>
            <!-- itinerary cards -->
            <div class="itinerary_cards">
              <!-- Single Card -->
              <div class="itinerary_card">
                <div class="itinerary_card_head">
                  <h3>旅行團資料</h3>
                  <div class="tourcode">
                    團號:
                    <span id="label_PackageCode">{{itinCode}}</span>
                    <span id="label_testmsg"></span>
                  </div>
                </div>
                <div class="itinerary_card_body">
                  <div class="updatePanel">
                    <div class="updatePanel_videoGrp">
                      <span #sliderWrapper *ngIf="imgFileList.length>1">
                        <ng-image-slider #nav [images]="imgCollection" [imageSize]="{width: 360, height: 260, space: 10}" [autoSlide]="1" [infinite]="true" [manageImageRatio]="true"></ng-image-slider>
                      </span>
                      <div style="min-width: 360px; min-height: 260px; width: 360px; height: 260px; overflow: hidden;" *ngIf="imgFileList.length==1">
                        <img #ratioImg src="assets/img/tour/{{itinCode}}/{{imgFileList[0].tourImageName}}" style="width:360px; height:260px">
                      </div>
                      <span *ngIf="imgFileList.length==0">
                        <img src="assets/img/tour/blank_img01.jpg" style="width:360px; height:260px">
                      </span>


                      <p>
                        溫馨提示:
                        行程資料只供參考，確切行程內容、自選活動內容、酒店、餐膳等會因應季節、天氣、交通或其他因素而有所變動，以報名時取得的文字行程表為準
                        謝謝！
                      </p>
                    </div>
                    <div class="updatePanel_text">
                      <p>
                        {{TourList[0].tourName}}
                      </p>
                      <div class="updatePanel_text_desc">
                        <ul>
                          <li style="font-size:large">行程特點</li>
                         <!-- <li style="font-size:large">此團隊贈送蘇黎世旅遊保險</li> -->
                          <li style="font-size:medium" [innerHTML]="TourList[0].highlight">
                          </li>
                        </ul>
                      </div>
                      <div class="updatePanel_button">
                        <button type="submit" (click)="dlPDF(TourList[0].brochureLink,'T')">下載行程</button>

                        <div  *ngIf="TourList[0].selfpaidpdf!=''" >
                          <div *ngFor="let selfpaid of TourList[0].selfpaidpdf.split(',')" style="padding:5px">
                            <button type="submit" (click)="dlPDF(selfpaid,'S')" style="margin-left:10px; background-color: blue; width:250px ">下載自費節目表({{selfpaid.split('自費節目表')[0]}})</button>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div  class="itinerary_card">
                  <div class="itinerary_card_head">
                    <h3>出發日期 {{ chooseDate }}</h3>
                    <div style="display:flex">
                    <span style="background-color:red; width:100px; text-align:center; margin-right:5px;border-color:white;border:solid;font-weight:bold"><iconify-icon icon="mingcute:fire-fill" ></iconify-icon>快將成團</span>
                    <span style="background-color:#EFE405; width:100px; text-align:center; margin-right:5px;color:black;font-weight:bold;">有位</span>
                    <span style="background-color:#300CF5; width:100px; text-align:center; color:white;font-weight:bold;">少量</span>
                    </div>

                  </div>
                  <div  class="itinerary_card_body ng-calendar" >
                    <div  class="ng-calendar-year" style="margin-bottom: 10px;">
                      <full-calendar 
                        [options] = "calendarOptionsList"
                        #yearCalendar
                        ></full-calendar>
                     </div>
                    
                    <div class="ng-calendar-day" >
                     <full-calendar 
                        [options]="calendarOptions"
                        #dayCalendar
                      ></full-calendar>
                    </div>
                  </div>
              </div>
              <!-- Single Card -->
              <div class="itinerary_card">
                <div class="itinerary_card_head">
                  <h3>旅行團資料</h3>
                </div>
                <div class="itinerary_card_body">
                  <table class="itinerary_card_table">
                    <tbody>
                      <tr>
                        <td>暫定航空公司: {{ transportation }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Single Card -->
              <div class="itinerary_card">
                <div class="itinerary_card_head">
                  <h3>
                    <span>即時報團(編號：{{tourCode}})</span> <br />
                    <span>旅行團顧客人數 (*所有價錢以港幣計算)</span>
                  </h3>
                </div>
                <div class="itinerary_card_body">
                  <div class="updatePanelPrice">
                    <table class="updatePanelPrice_table">
                      <thead>
                        <tr>
                          <td></td>
                          <td><span>團費</span></td>
                          <td><span>人數</span></td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>成人(佔半房)(每位)</td>
                          <td>
                            <span class="labelAdultPrice">{{ adtPrice|currency: 'HKD':'symbol-narrow': '0.0'}} 起</span>
                          </td>
                          <td>
                            <div class="price_input-group">
                              <button type="button" class="btn minus">-</button>
                              <input
                                id="txtAdtPrice"
                                type="text"
                                [value]="this.adt"
                                class="price_input-number pax-num-control"
                              />
                              <button type="button" class="btn plus">+</button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            小童(佔床)(每位) <br />
                            <span>*小童2-11歲 (小童歲數以回程日作準)</span>
                          </td>
                          <td>
                            <span class="labelAdultPrice">{{uchPrice|currency: 'HKD': 'symbol-narrow': '0.0'}}起</span>
                          </td>
                          <td>
                            <div class="price_input-group">
                              <button type="button" class="btn minus">-</button>
                              <input
                                id="txtUchPrice"
                                type="text"
                                [value]="uch"
                                class="price_input-number pax-num-control"
                              />
                              <button type="button" class="btn plus">+</button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            小童(不佔床)(每位)<br />
                            <span>*小童2-11歲 (小童歲數以回程日作準)</span>
                          </td>
                          <td>
                            <span class="labelAdultPrice">{{chdPrice|currency: 'HKD': 'symbol-narrow': '0.0'}}起</span>
                          </td>
                          <td>
                            <div class="price_input-group">
                              <button type="button" class="btn minus">-</button>
                              <input
                                id="txtChdPrice"
                                type="text"
                                [value]="chd"
                                class="price_input-number pax-num-control"
                              />
                              <button type="button" class="btn plus">+</button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>單人房附加費</td>
                          <td><span class="labelAdultPrice">{{otherChargeAmount|currency: 'HKD': 'symbol-narrow': '0.0'}}</span></td>
                          <td>
                            <div class="price_input-group" style="width:180px">
                              如單數人數報名，需繳付單人房附加費，敬請留意。
                            </div>
                          </td>
                        </tr>
                        <tr><td colspan=4><hr></td></tr>
                        <tr>
                          <td>{{ lblDiscount }}</td>
                        <tr>
                        <tr *ngFor="let discountData of discountList">
                          <td>{{ discountData.discountName}}</td>
                          <td>{{ discountData.discountAmount|currency: 'HKD': 'symbol-narrow': '0.0'}}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Single Card -->
              <div class="itinerary_card">
                <div class="itinerary_card_head">
                  <h3>產品條款及細則</h3>
                </div>
                <div class="itinerary_card_body">
                  <div class="UpdatePanelTAC">
                    <ul>
                      <li>
                        本公司將收取客人印花成本。印花成本以最終總收費之0.15%計算。
                      </li>
                      <li>
                        有關此團之旅行團團費、稅項及服務費等費用，請參閱分行派發之價目資料表或網站。
                      </li>
                      <li>
                        如單數人數(如1，3，5位等等)報名，需於報名時一併繳付單人房附加費，敬請留意。
                      </li>
                      <li>
                        ⁠⁠有關嬰兒(2歲以下)價錢，請聯絡客服人員查詢明細價錢。
                      </li>
                    </ul>
                    <div class="UpdatePanelTAC_check">
                      <label class="checkbox-container">
                        <input type="checkbox" [(ngModel)]="agreement"/>
                        <span class="checkmark"></span>
                        我已細閱及同意以上的條款及細則
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- itinerary_permision -->
              <div class="itinerary_permision">
                <button type="button" class="btn btn_danger" (click)="goBack()">返回</button>
                <button type="button" class="btn btn_primary" (click)="loadBookingPage()">確認</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
